import { Injectable } from '@angular/core';
import { ArticleTypeStore } from './article-type.store';
import { ArticleTypeQuery } from './article-type.query';
import { BaseFacade } from "../base/base.facade";
import { ArticleTypeService } from './article-type.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class ArticleTypeFacade extends BaseFacade {
    constructor(
        articleTypeService: ArticleTypeService,
        articleTypeStore: ArticleTypeStore,
        articleTypeQuery: ArticleTypeQuery,
        dynamicSchemaFactory: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(articleTypeService,
          articleTypeStore,
          articleTypeQuery,
          dynamicSchemaFactory.getDynamicSchemaFacade('article-type'),
          translateService,
          'article-type-facade');
    }
}
